import React, { useState, useEffect } from 'react'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import { Box, useTheme, IconButton, TextField, MenuItem, Typography, Stack } from '@mui/material'

export default function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const [pageArr, setPageArr] = useState([]);

    useEffect(() => {
        let totalPage = Math.ceil(count / rowsPerPage);
        // let arr = []
        // for (let i = 1; i <= totalPage; i++) {
        //     arr.push(i);
        // }
        setPageArr(totalPage);
    }, [count, rowsPerPage]);
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    const handlePageSelect = (event) => {
        onPageChange(event, event.target.value - 1)
    }

    return (
        <Box className='tablepagination' sx={{ flexShrink: 0, ml: 2.5 }}>


            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
                sx={{color: theme.palette.primary.text}}
            >
                {theme.direction === 'rtl' ? <SkipNextIcon  /> : <SkipPreviousIcon  />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
                sx={{color: theme.palette.primary.text}}
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight  /> : <KeyboardArrowLeft  />}
            </IconButton>
            <Stack className='flex justify-center items-center bg-[#FFFF] mr-[10px] w-[20px] h-[20px] rounded-[4px] border-[1.5px] border-[grey] font-medium'>
                <Typography color={theme.palette.primary.text} className='!text-[13px] '>{page + 1}</Typography>
            </Stack>
            <Typography color={theme.palette.primary.text} className='!text-[13px] font-medium'>of</Typography>
            <Typography color={theme.palette.primary.text} className='font-medium !ml-[10px] !text-[13px] '>{pageArr}</Typography>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
                sx={{color: theme.palette.primary.text}}
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
                sx={{color: theme.palette.primary.text}}
            >
                {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}
            </IconButton>
        </Box>
    );
}